import React, { Fragment } from 'react';
import { useHistory } from "react-router-dom";
import { Grid, Box, Typography } from '@material-ui/core';
import { handleSnackBar } from "../../../store/global/actions";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUserId } from '../../../store/auth/selectors';
import Dialog from "../../atoms/dialog";
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService } from '../../../store/global/actions'

export default function LeaveFromTeam({ sharedMembers, isLeave, setIsLeave, blueprintDetails, getSharedList}) {
    const dispatch = useDispatch();
    const history = useHistory();
    const loggedInUserId = useSelector(getLoggedInUserId);
    const memberDetails = sharedMembers.find(ele => ele.userId._id === loggedInUserId);
    
    const handleClose = () => {
        setIsLeave(false);
    }
    const onLeaveFromTeam = () => {
        if (memberDetails === undefined) {
            return;
        }
        dispatch(invokePostService('leaveFromTeam', {}, [memberDetails._id])).then(res => {
            setIsLeave(false);
            if (res?.status == true) {
                getSharedList();
                history.push(`/`);
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "success" }));
            } 
        });
    }
    return (<Dialog
        open={isLeave}
        handleClose={handleClose}
    >
        <Box>

            <Grid xs={12} style={{ marginBottom: 20 }}>

                <Fragment>
                    <Typography> Are you sure you want to leave from {blueprintDetails.name} ? </Typography>
                </Fragment>

            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                <DeleteCancel onCancel={handleClose} onDelete={onLeaveFromTeam} content='Leave'/>
            </Grid>

        </Box>

    </Dialog >)
}